<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileDisplayLocal',
})
</script>
<template>
  <div :class="bem([{ block }, theme])">
    <FileIcon type="icon-upload" />
    <div :class="bem('info')">
      <div :class="bem('name')">{{ fileName }}</div>
      <div :class="bem('size')">{{ friendBytes(size) }}</div>
    </div>
    <DeleteOutlined v-if="closeable" :class="bem('del')" @click="$emit('del')" />
  </div>
</template>

<script lang="ts" setup name="FileDisplayLocal">
import { createNamespace, friendBytes } from '@bd/vue3-utils'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { FileIcon } from '-/Base/BdIcon'
import { fileDisplayLocalProps } from './props'

defineProps(fileDisplayLocalProps)
defineEmits(['del'])
const [_, bem] = createNamespace('FileDisplayLocal')
</script>

<style lang="less">
.file-display-local {
  display: inline-flex;
  align-items: center;
  padding: @padding-sm @padding-md;
  border-radius: @border-radius-large;

  &--block {
    display: flex;
  }

  &--dark {
    background: @bg-fade-0;
  }

  &--light {
    background: @white;
  }

  .anticon {
    font-size: 36px;
  }

  &__info {
    flex: 1;
    padding-left: @padding-md;
  }

  &__name {
    .text-show-row(20px);
    font-weight: 700;
  }

  &__size {
    color: @text-color-secondary;
  }

  &__del {
    .active(@error-color, @text-color-secondary);
    font-size: 16px !important;
  }
}
</style>
